<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NlcdZG/tc-custom/9781634861625.jpg?1723405517010" alt="This image is the cover for the book Colin and Martin's Christmas Collection Box Set, Colin and Martin"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Colin and Martin's Christmas Collection Box Set, Colin and Martin
      </h1>
      <p class="bookDescription body article font2">
        <p>By popular demand, all four of Drew Hunt's best-selling Colin and Martin Christmas stories have been brought together in a single box set. Share in Colin Rogers and Martin Kellam’s lives as seen through four very different Christmases:<br/><br/><strong>First Christmas</strong>-- Blind since birth, Martin orders groceries online. It doesn’t hurt that the man who brings them has a sexy voice. Colin usually leaves Martin’s deliveries until last so he can spend extra time with the man he has a secret longing to protect. When Martin offers to cook Christmas dinner for Colin, will turkey and stuffing be all that’s on the menu?<br/><br/><strong>London Christmas</strong>-- Colin and Martin got together at Christmas five years ago. But could this be their last? Martin can’t forgive Colin for leaving the gate open, allowing Toby, Martin’s guide dog, to escape and die on the road. Will the spirit of Christmas, the warmth of Colin’s family, and the thrills of London be enough to fix their relationship?<br/><br/><strong>Australian Christmas</strong>-- While spending Christmas down under with Colin’s uncle Matt, Colin and Martin can’t help but play matchmakers between Matt and Bruce, the foreman on Matt’s sheep station. Can Matt risk his heart to the man he’s loved from afar for years?<br/><br/><strong>Goodbye Christmas</strong>-- Colin and Martin have one final Christmas with Colin’s parents before emigrating to Australia. When his mum reveals bad news, Colin is torn between family obligation and the future he and Martin have longed for. Can Martin show him he can have both?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Drew Hunt
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?967a37c4